// Toast Notification System

// Parse error messages to extract human-readable content
function parseErrorMessage(rawMessage) {
    if (!rawMessage) return window.i18n?.t('notifications.unknownError') || 'An unknown error occurred';

    // Check if message contains JSON error structure
    if (rawMessage.includes('{') && rawMessage.includes('"detail"')) {
        try {
            // Extract service name from prefix (e.g., "ElevenLabs Error 401:")
            const serviceMatch = rawMessage.match(/^([\w\s]+)(?:Error|error)\s+(\d+)?:?/i);
            const serviceName = serviceMatch ? serviceMatch[1].trim() : '';
            const errorCode = serviceMatch && serviceMatch[2] ? serviceMatch[2] : '';

            // Extract JSON part
            const jsonMatch = rawMessage.match(/{.*}/);
            if (jsonMatch) {
                const errorData = JSON.parse(jsonMatch[0]);

                // Build human-readable message
                let message = '';

                if (serviceName) {
                    message += serviceName;
                    if (errorCode) message += ` (${errorCode})`;
                    message += ': ';
                }

                // Extract the actual error message from various JSON structures
                if (errorData.detail?.message) {
                    message += errorData.detail.message;
                } else if (errorData.detail) {
                    message += typeof errorData.detail === 'string' ? errorData.detail : JSON.stringify(errorData.detail);
                } else if (errorData.message) {
                    message += errorData.message;
                } else if (errorData.error) {
                    message += errorData.error;
                } else {
                    // Fallback to original message if we can't parse it
                    return rawMessage;
                }

                return message;
            }
        } catch (e) {
            console.warn('Failed to parse error message:', e);
            // Return original message if parsing fails
        }
    }

    // Return as-is if no JSON detected
    return rawMessage;
}

function showToast(message, type = 'error', duration = 5000) {
    // Dynamically import i18n if available
    const i18n = window.i18n;
    const toastContainer = document.getElementById('toastContainer');

    // Create toast element
    const toast = document.createElement('div');
    toast.className = `toast ${type}`;

    // Set icon based on type
    const icons = {
        error: '❌',
        success: '✅',
        info: 'ℹ️'
    };

    // Set title based on type
    const titles = {
        error: i18n?.t('notifications.error') || 'Error',
        success: i18n?.t('notifications.success') || 'Success',
        info: i18n?.t('notifications.info') || 'Info'
    };

    toast.innerHTML = `
        <div class="toast-icon">${icons[type] || icons.error}</div>
        <div class="toast-content">
            <div class="toast-title">${titles[type] || titles.error}</div>
            <div class="toast-message">${message}</div>
        </div>
        <button class="toast-close" onclick="this.parentElement.remove()">×</button>
    `;

    toastContainer.appendChild(toast);

    // Auto-remove after duration
    if (duration > 0) {
        setTimeout(() => {
            toast.style.animation = 'slideInRight 0.3s ease-out reverse';
            setTimeout(() => toast.remove(), 300);
        }, duration);
    }
}

export { showToast, parseErrorMessage };
